import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { OdinBaseQuery } from './core';
import { CacheTags, ClientAdminRequest, PaginatedRequest } from 'types';
import { UnitOfMeasure } from './bindings/UnitOfMeasure';
import { FetchResponse } from './bindings/FetchResponse';
import { UnitOfMeasureResponse } from './bindings/UnitOfMeasureResponse';
import { PostUnitOfMeasureRequest } from './bindings/PostUnitOfMeasureRequest';
import { PutUnitOfMeasureRequest } from './bindings/PutUnitOfMeasureRequest';

export const uomApi = createApi({
  reducerPath: 'uoms',
  baseQuery: OdinBaseQuery,
  tagTypes: [CacheTags.uoms],
  endpoints: (builder) => ({
    fetchUoms: builder.query<
      FetchResponse<UnitOfMeasureResponse>,
      PaginatedRequest
    >({
      query: (payload) => ({
        url: `/api/units-of-measurement`,
        method: 'GET',
        params: payload,
      }),
      providesTags: (payload) => [
        { type: CacheTags.uoms, id: CacheTags.partial },
        ...(payload?.items.map((uom) => ({
          type: CacheTags.uoms,
          id: uom.id,
        })) ?? []),
      ],
    }),
    postUom: builder.mutation<UnitOfMeasureResponse, PostUnitOfMeasureRequest>({
      query: (payload) => ({
        url: `/api/units-of-measurement`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (payload) => {
        let returnValue = [{ type: CacheTags.uoms, id: CacheTags.partial }];
        if (payload) {
          returnValue = [
            ...returnValue,
            { type: CacheTags.uoms, id: payload.id },
          ];
        }
        return returnValue;
      },
    }),
    putUoms: builder.mutation<
      UnitOfMeasureResponse,
      { id: string } & PutUnitOfMeasureRequest
    >({
      query: (payload) => ({
        url: `/api/units-of-measurement/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: (payload) => {
        return [
          { type: CacheTags.uoms, id: CacheTags.partial },
          { type: CacheTags.uoms, id: payload?.id },
        ];
      },
    }),
    // fetchUoms: builder.query<FetchResponse<UnitOfMeasureResponse>,PaginatedRequest>>({
    //   query: (payload) => ({
    //     url: '/api/units-of-measurement',
    //     method: 'GET',
    //     params: payload,
    //   }),
    //   providesTags: (payload) => [
    //     { type: CacheTags.uoms, id: CacheTags.partial },
    //     ...(payload?.map((uom) => ({
    //       type: CacheTags.uoms,
    //       id: uom.id,
    //     })) ?? []),
    //   ],
    // }),

    // saveUoms: builder.mutation<
    //   UnitOfMeasure[],
    //   { clientId: string; items: UnitOfMeasure[] }
    // >({
    //   query: (payload) => ({
    //     url: '/api/units-of-measurement',
    //     method: 'PUT',
    //     body: payload.items,
    //     params: { clientId: payload.clientId },
    //   }),
    // }),
  }),
});

export const { useFetchUomsQuery, usePostUomMutation, usePutUomsMutation } =
  uomApi;
